(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hero-video]');
    if (!trigger) return;

    const videoId = trigger.dataset.videoId;
    const iframe = document.createElement('iframe');
    iframe.className = 'hero__video-embed';
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.title = trigger.querySelector('.hero__video-caption')?.textContent.trim() || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');

    trigger.replaceWith(iframe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-thumbnail]').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      var gallery = thumbnail.closest('.product__gallery');
      var mainImage = gallery.querySelector('.product__main-image-img');
      if (mainImage) {
        // `image_tag` gives the main image a srcset, which the browser picks
        // from ahead of `src` — so swapping `src` alone never changed the
        // picture (BugHerd #164). Drop the srcset/sizes and swap the alt too.
        var thumbnailImage = thumbnail.querySelector('img');
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumbnail.dataset.fullSrc;
        if (thumbnailImage) {
          mainImage.alt = thumbnailImage.alt;
        }
      }
      gallery.querySelectorAll('[data-product-thumbnail]').forEach(function (el) {
        el.classList.remove('is-active');
      });
      thumbnail.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
